import { AppData } from '../types/index';

export const appDataFR: AppData = {
  categories: [
    {
      id: "boat-tours",
      title: "Excursions en Bateau",
      route: "/boat-tours",
      description: "Explorez la côte de l'Algarve avec nos excursions en bateau de luxe",
      image: "ai-generated-boat-picture.jpg",
      items: [
        {
          id: 1,
          name: "Ocean Quest",
          email: "info@oceanquest.com",
          logo: "Ocean Quest.png",
          description: "Explorez le meilleur de la côte de l'Algarve avec Ocean Quest. Croisières en bateau, grottes, dauphins et parasailing à Vilamoura, avec une équipe passionnée de fournir des expériences uniques à la mer. Parce que la vie est belle.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 18:00" },
            { day: "Mardi", hours: "09:00 - 18:00" },
            { day: "Mercredi", hours: "09:00 - 18:00" },
            { day: "Jeudi", hours: "09:00 - 18:00" },
            { day: "Vendredi", hours: "09:00 - 18:00" },
            { day: "Samedi", hours: "09:00 - 18:00" },
            { day: "Dimanche", hours: "09:00 - 18:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 683",
          socialMedia: {
            facebook: "https://www.facebook.com/boattripsvilamoura",
            instagram: "https://www.instagram.com/oceanquestalgarve/",
            website: "https://oceanquestalgarve.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sOcean%20Quest!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "ocean quest",
          images: ["see-the-wonderful-algarvian.jpg", "swimming-stop.jpg", "traditional-cultural (1).jpg", "vilamoura-yacht-charter.jpg", "vilamoura-speed-boat-trips.jpeg", "cesar-live-on-the-guitar.jpg", "traditional-cultural.jpg", "life-is-beautiful.jpg", "exceptional-view.jpg", "dolphin-quest.jpg"]
        },
        {
          id: 2,
          name: "Cool Charters",
          email: "info@coolchartersvilamoura.com",
          logo: "Cool-Charters-BSQUAREwhite.png",
          description: "Offre des expériences nautiques personnalisées, idéales pour les occasions spéciales comme les anniversaires, les enterrements de vie de garçon/jeune fille, les mariages ou les événements d'entreprise. Les excursions comprennent des visites de grottes, de plages isolées et l'observation des dauphins, ainsi que des activités nautiques comme le jet ski. L'équipe dévouée assure un service exceptionnel, créant des souvenirs inoubliables en mer.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 00:00" },
            { day: "Mardi", hours: "09:00 - 00:00" },
            { day: "Mercredi", hours: "09:00 - 00:00" },
            { day: "Jeudi", hours: "09:00 - 00:00" },
            { day: "Vendredi", hours: "09:00 - 00:00" },
            { day: "Samedi", hours: "09:00 - 00:00" },
            { day: "Dimanche", hours: "09:00 - 00:00" }
          ],
          address: "Marina de Vilamoura",
          phone: "+351 912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/coolchartersvilamoura",
            instagram: "https://www.instagram.com/coolchartersvilamoura/",
            website: "https://coolchartersvilamoura.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.114271710697!2d-8.121552223229203!3d37.078585172169184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab593e20c0315%3A0xdbad05ad5ff33887!2sCool%20Charters!5e0!3m2!1spt-PT!2spt!4v1748883117704!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["5% DE RÉDUCTION"]
          },
          rootFolder: "Cool Charters",
          images: [
            "3e7042db-69f6-4f1f-b8b0-487e20a38ce7.jpeg",
            "b8ce1f17-7758-47d7-9ad8-f4e8d68f6bc5.jpeg",
            "c7a1cfb6-68cf-4491-b024-306646e95c5e.jpeg",
            "cc5c2fdf-0363-4d44-a721-5c1e3dd2343d.jpeg",
            "caption.jpg",
            "caption (1).jpg",
            "caption (2).jpg",
            "discover-algarve-s-famous.jpg",
            "you-will-find-a-wonderful.jpg",
            "background5.jpg",
            "kerry-is-vilamoura-s.jpg",
            "cool.jpg"
          ]
        },
        {
          id: 3,
          name: "AlgarExperience",
          email: "info@algarexperience.com",
          logo: "algarexperience-vect.svg",
          description: "AlgarExperience est un leader dans le tourisme maritime dans l'Algarve, offrant des expériences uniques comme des visites de grottes, des observations de dauphins, du parasailing et des barbecues sur la plage. Avec un parc de bateaux modernes et une équipe dédiée, il offre des moments inoubliables à la mer.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 20:00" },
            { day: "Tuesday", hours: "09:00 - 20:00" },
            { day: "Wednesday", hours: "09:00 - 20:00" },
            { day: "Thursday", hours: "09:00 - 20:00" },
            { day: "Friday", hours: "09:00 - 20:00" },
            { day: "Saturday", hours: "09:00 - 20:00" },
            { day: "Sunday", hours: "09:00 - 20:00" }
          ],
          address: "Algarve",
          phone: "+351 912 345 681",
          socialMedia: {
            facebook: "https://www.facebook.com/algarexperiencee",
            instagram: "https://www.instagram.com/algarexperience/",
            website: "https://algarexperience.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.162307877745!2d-8.126925009001342!3d37.077441000410495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab57f81075ba9%3A0x7aa138f8f2a3e9ed!2sAlgarExperience%20-%20Marina%20de%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748883329499!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "AlgarExperience",
          images: ["caves-coastline-tour.jpg", "dolphin-caves-catamaran.jpg", "gruta-de-benagil.jpg", "sunset.jpg", "grutas.jpg", "vista-aerea.jpg", "barbecue-na-praia.jpg", "parasailing.jpg", "belize-segundo-costa.jpg", "boat-party.jpg"]
        },
        {
          id: 4,
          name: "Condor de Vilamoura",
          email: "info@condorvilamoura.com",
          logo: "condor_logo branco.avif",
          description: "Découvrez la côte de l'Algarve sur le majestueux Condor de Vilamoura, un schooner de 34 mètres de long inspiré par les schooners américains du 19ème siècle. Avec une capacité pour 120 passagers, il offre des croisières de 3 heures à Praia da Galé et des croisières de journée à Benagil, avec des escales pour la plage, l'exploration des grottes et la dégustation d'un délicieux barbecue sur la plage. Une expérience unique pour toute la famille, combinant confort, tradition et paysages impressionnants.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 18:00" },
            { day: "Tuesday", hours: "09:00 - 18:00" },
            { day: "Wednesday", hours: "09:00 - 18:00" },
            { day: "Thursday", hours: "09:00 - 18:00" },
            { day: "Friday", hours: "09:00 - 18:00" },
            { day: "Saturday", hours: "09:00 - 18:00" },
            { day: "Sunday", hours: "09:00 - 18:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 682",
          socialMedia: {
            facebook: "https://www.facebook.com/CondorDeVilamoura/",
            instagram: "https://www.instagram.com/condordevilamoura/",
            website: "https://condorvilamoura.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.126789!3d37.076543!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "condor vilamoura",
          images: ["photo0jpg.jpg", "caption (1).jpg", "vamos-para-a-praia.jpg", "caption (2).jpg", "caption.jpg", "21d228_8a694355938d49048feaba57ef829db2~mv2-1.avif", "condor-de-vilamoura (1).jpg", "condor-de-vilamoura.jpg", "21d228_28814368cb5446c1b0a8d17d8459fd48~mv2.avif", "21d228_8a694355938d49048feaba57ef829db2~mv2.avif"]
        },
        {
          id: 5,
          name: "Vilamoura WaterSports Centre",
          email: "info@vilamourawatersportscentre.com",
          logo: "Vilamoura-Watersports-Centre-logo-Design-01-e1602070771419.webp",
          description: "Situé à Vilamoura Marina, le Vilamoura Watersports Centre offre une large gamme d'activités aquatiques pour tous les âges. Des croisières en bateau aux grottes de Benagil, observation de dauphins, parasailing, jet ski, wakeboard, pêche et locations de bateaux privés, il y a des options pour tout le monde. Avec une équipe expérimentée et des équipements de qualité, ils garantissent la sécurité et le plaisir dans toutes les expériences. Ouvert quotidiennement, c'est le lieu idéal pour explorer la côte de l'Algarve de manière unique.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "09:00 - 23:00" },
            { day: "Tuesday", hours: "09:00 - 23:00" },
            { day: "Wednesday", hours: "09:00 - 23:00" },
            { day: "Thursday", hours: "09:00 - 23:00" },
            { day: "Friday", hours: "09:00 - 23:00" },
            { day: "Saturday", hours: "09:00 - 23:00" },
            { day: "Sunday", hours: "09:00 - 23:00" }
          ],
          address: "Vilamoura",
          phone: "+351 912 345 684",
          socialMedia: {
            facebook: "https://www.facebook.com/VilamouraWatersportsCentre/?locale=pt_PT",
            instagram: "https://www.instagram.com/vilamoura_watersportscentre/",
            website: "https://www.watersportsvilamoura.com/pt-pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1531357987783!2d-8.124483123229288!3d37.07765947216944!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab591f6e9b21f%3A0x407948f711a9e5ab!2sVilamoura%20Watersports%20Centre!5e0!3m2!1spt-PT!2spt!4v1748883466872!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "watersports vilamoura",
          images: ["IMG_1046-scaled.webp", "photo5jpg.jpg", "foto1.webp", "jet-boat-ride-vilamoura.jpg", "Parasailing-Vilamoura-Experience-scaled.webp", "speed-boat-algarvexcite.jpg", "parasailing-boat-trips.jpg", "common-dolphin.jpg", "Fishing-In-Algarve.webp", "Dolphins-Algarve-.webp"]
        },
        {
          id: 6,
          name: "Passeios Ria Formosa",
          email: "info@passeiosriaformosa.com",
          logo: "riaformosa.png",
          description: "Explorez la beauté naturelle de la Ria Formosa avec nos visites guidées. Observez les oiseaux marins, découvrez des îles désertes et apprenez-en davantage sur l'écosystème unique de cette zone protégée. Visites disponibles pour petits et grands groupes, avec des guides expérimentés et compétents.",
          locationIds: [0],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 18:00" },
            { day: "Mardi", hours: "09:00 - 18:00" },
            { day: "Mercredi", hours: "09:00 - 18:00" },
            { day: "Jeudi", hours: "09:00 - 18:00" },
            { day: "Vendredi", hours: "09:00 - 18:00" },
            { day: "Samedi", hours: "09:00 - 18:00" },
            { day: "Dimanche", hours: "09:00 - 18:00" }
          ],
          address: "Marina de Tavira",
          phone: "+351 923 456 789",
          socialMedia: {
            facebook: "https://www.facebook.com/passeiosriaformosa",
            instagram: "https://www.instagram.com/passeiosriaformosa/",
            website: "https://passeiosriaformosa.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.114271710697!2d-8.121552223229203!3d37.078585172169184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab593e20c0315%3A0xdbad05ad5ff33887!2sCool%20Charters!5e0!3m2!1spt-PT!2spt!4v1748883117704!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "Passeios Ria Formosa",
          images: ["sailing-tour.jpg", "featured-2-horas-fuseta.webp", "birdwatching.jpg", "sealife-observation.jpg", "dolphins-observation.jpg", "DJI_20240427_200812_220.webp", "dji_fly_20240425_145136_206_1714164247660_timed.webp"]
        },
        {
          id: 7,
          name: "Formosamar",
          email: "info@formosamar.com",
          logo: "formosamar-main-logo-landscape-white.svg",
          description: "Formosamar, située à Faro, propose des expériences authentiques dans le Parc Naturel de la Ria Formosa. Elle propose des excursions en bateau, des observations d'oiseaux et de dauphins, ainsi que des locations de bateaux, de kayaks, de vélos et d'équipements nautiques. Idéal pour ceux qui souhaitent explorer la nature et la culture locale avec des guides expérimentés. L'entreprise est certifiée en écotourisme et s'engage dans des pratiques durables.",
          locationIds: [5],
          openingHours: [
            { day: "Monday", hours: "09:00 - 19:00" },
            { day: "Tuesday", hours: "09:00 - 19:00" },
            { day: "Wednesday", hours: "09:00 - 19:00" },
            { day: "Thursday", hours: "09:00 - 19:00" },
            { day: "Friday", hours: "09:00 - 19:00" },
            { day: "Saturday", hours: "09:00 - 19:00" },
            { day: "Sunday", hours: "09:00 - 19:00" }
          ],
          address: "Ria Formosa",
          phone: "+351 912 345 680",
          socialMedia: {
            facebook: "https://www.facebook.com/formosamar/",
            instagram: "https://www.instagram.com/formosamar/",
            website: "https://formosamar.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3185.8047220482727!2d-7.9389662732313235!3d37.014454772187065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd05533874923d89%3A0xd4bf971caf98216!2sFormosamar%20-%20Boat%20Tours%20Passeios%20na%20Ria%20Formosa!5e0!3m2!1spt-PT!2spt!4v1748883209882!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["5% DE RÉDUCTION"]
          },
          rootFolder: "Formosamar",
          images: ["dolphin-watching-boat.jpg", "formosamar-sailboats-ria-formosa-island.jpg", "ria-formosa-islands-boat.jpg", "ilha-deserta-and-farol.jpg", "guided-boat-trip-in-ria.jpg", "formosamar-private-tour-cruise-ria-formosa-900x500.jpg", "formosamar.jpg", "formosamar (1).jpg", "formosamar (2).jpg"]
        },
      ]
    },
    {
      id: "gastronomy",
      title: "Gastronomie",
      route: "/gastronomy",
      description: "Découvrez une cuisine exquise dans des restaurants sélectionnés",
      image: "pexels-pixabay-262978.jpg",
      items: [
        {
          id: 1,
          name: "Gran Sorvete",
          email: "info@gransorvete.com",
          logo: "GranSorvete.avif",
          type: "Café et glace",
          description: "Le Gran Sorvete, situé à la Marina de Vilamoura, est réputé pour ses glaces artisanales italiennes, ses crêpes et ses gaufres préparées sur place. Dans une ambiance chaleureuse et conviviale, avec une vue imprenable sur la marina et ses yachts, c’est l’endroit idéal pour savourer une douceur à tout moment de la journée. Que ce soit pour se rafraîchir lors d’un après-midi d’été, profiter d’une collation détendue ou terminer une promenade le long de la marina avec quelque chose de spécial, le Gran Sorvete est une étape incontournable pour tous ceux qui apprécient la qualité et le goût.",
          locationIds: [3],
          priceRange: 1,
          openingHours: [
            { day: "Monday", hours: "11:00 - 23:00" },
            { day: "Tuesday", hours: "11:00 - 23:00" },
            { day: "Wednesday", hours: "11:00 - 23:00" },
            { day: "Thursday", hours: "11:00 - 23:00" },
            { day: "Friday", hours: "11:00 - 23:00" },
            { day: "Saturday", hours: "11:00 - 23:00" },
            { day: "Sunday", hours: "11:00 - 23:00" }
          ],
          address: "Rua Gran Sorvete, 23",
          phone: "912 345 682",
          socialMedia: {
            facebook: "https://www.facebook.com/GranSorveteVilamoura/",
            instagram: "https://www.instagram.com/gransorvete/",
            website: "https://gransorvete.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.113234707878!2d-8.12375902322921!3d37.078609872169125!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5d5d983cd55%3A0xec7bb7c81350d92!2sGran%20sorvete!5e0!3m2!1spt-PT!2spt!4v1748882811766!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "Gran Sorvete",
          images: ["crepes-also-served-with.jpg", "gran-gelato.jpg", "gran-sorvete-in-the-heart.jpg", "in-the-heart-of-the-vilamoura.jpg", "our-delicious-mini-pancakes.jpg", "hot-chocolate-served.jpg", "enjoy-the-delicious-combinatio.jpg", "gran-gelato (1).jpg"]
        },
        {
          id: 2,
          name: "Retinto - Rodízio & Wine",
          email: "retinto.vilamoura@gmail.com",
          logo: "Retinto+Vilamoura-330w.webp",
          type: "Steakhouse",
          description: "Le Retinto Rodízio & Wine, à Vilamoura, se distingue par son buffet de viande brésilienne et argentine, accompagné d'une sélection de vins soigneuse. Ambiance chaleureuse et excellent service.",
          locationIds: [3],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "18:30 - 23:30" },
            { day: "Tuesday", hours: "18:30 - 23:30" },
            { day: "Wednesday", hours: "18:30 - 23:30" },
            { day: "Thursday", hours: "18:30 - 23:30" },
            { day: "Friday", hours: "18:30 - 23:30" },
            { day: "Saturday", hours: "18:30 - 23:30" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Rua Retinto, 56",
          phone: "912 345 683",
          socialMedia: {
            facebook: "https://www.facebook.com/Retinto.Vilamoura/",
            instagram: "https://www.instagram.com/retinto.vilamoura/",
            website: "https://www.restauranteretinto.com/retinto-rodizio-n-wine"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.0845960567867!2d-8.121846809000903!3d37.07929200040834!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5940c8ecbd9%3A0x6755304fce06bfca!2sRetinto%20-%20Rod%C3%ADzio%20%26%20Wine%20-%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748882848562!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Boisson de bienvenue",
            description: ["Boisson de bienvenue au vin mousseux"]
          },
          rootFolder: "Retinto",
          images: ["5c594138-f690-4ea1-add1-3fce2e15ef55.avif", "photo0jpg.jpg", "entrecote-argentino-ribye.jpg", "ff1ed75b-d71b-42f7-9d93-7f3a39464c45.jpg", "59f45f21-e373-42d3-8ed2-8946008e0b3f.jpg", "b15f5500-b73f-421d-b7bc-a9412784f5d8.webp", "b8685ec1-a1b4-4cbd-bd41-3b8cdb1bfa11.avif", "d56aaf4a-be2e-4cd3-99d9-f70d63c5826c.avif", "7701aa02-a0c2-4ec5-9af1-e1c80a4263d6.webp"],
          menuUrl: "https://www.restauranteretinto.com/retinto-rodizio-n-wine#Menu"
        },
        {
          id: 3,
          name: "Authentic",
          email: "reservations@authentic-restaurant.pt",
          logo: "Logo-Authentic-dourado.png",
          type: "Cuisine internationale",
          description: "Le restaurant Authentic, situé à Quinta do Lago, offre une expérience gastronomique sophistiquée, combinant la cuisine portugaise classique avec une touche contemporaine, dans une ambiance luxueuse et raffinée.",
          locationIds: [1],
          priceRange: 3,
          openingHours: [
            { day: "Lundi", hours: "Fermé" },
            { day: "Mardi", hours: "Fermé" },
            { day: "Mercredi", hours: "18:00 - 23:00" },
            { day: "Jeudi", hours: "18:00 - 23:00" },
            { day: "Vendredi", hours: "18:00 - 23:00" },
            { day: "Samedi", hours: "18:00 - 23:00" },
            { day: "Dimanche", hours: "18:00 - 23:00" }
          ],
          address: "Rua Authentic, 45",
          phone: "912 345 679",
          socialMedia: {
            facebook: "https://www.facebook.com/authenticrestaurant",
            instagram: "https://www.instagram.com/authenticrestaurant",
            website: "https://www.authenticrestaurant.pt"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.123456!3d37.134567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Boisson de Bienvenue",
            description: ["Boisson de bienvenue et 5 % de réduction sur le dîner"]
          },
          rootFolder: "Authentic",
          images: ["83dcbf96-9726-4f1b-a1c7-c13c5f223b98.avif", "5e949c5e-060e-457b-ad67-b7597677c446.avif", "44aa29bd-0300-47b5-9ba5-83d8b8b19bd1.avif", "4d07f2e9-70b3-4b8b-a1e1-91fe37279165.avif", "843ccb2d-bf51-4c6a-bf0d-24ab6463b44c.avif", "ff05a4b6-f867-4243-9e4b-7141f87220af.avif", "c4bd01b2-7c29-405a-94d6-b566a0328e36.avif", "44cf2c78-1fec-4650-9ed2-eedaf4708a25.avif", "036d2880-7465-460b-9c18-61260a3de321.avif", "f818d5b4-5d61-4cc5-b0eb-e90fd92ac501.avif"],
          menuUrl: "https://authentic-restaurant.pt/wp-content/uploads/2025/06/Authentic-Menu.pdf"
        },
        {
          id: 4,
          name: "CafeZique",
          email: "cafeziquept@gmail.com",
          logo: "CAFEZIQUE-487bb404-679w.webp",
          type: "Internationale & Méditerranéenne",
          description: "Le restaurant CaféZique, à Loulé, combine les saveurs algarviennes avec des techniques contemporaines, offrant une expérience gastronomique unique dans un environnement relaxé près du château.",
          locationIds: [2],
          priceRange: 2,
          openingHours: [
            { day: "Monday", hours: "19:00 - 22:30" },
            { day: "Tuesday", hours: "19:00 - 22:30" },
            { day: "Wednesday", hours: "19:00 - 22:30" },
            { day: "Thursday", hours: "19:00 - 22:30" },
            { day: "Friday", hours: "19:00 - 22:30" },
            { day: "Saturday", hours: "19:00 - 22:30" },
            { day: "Sunday", hours: "Closed" }
          ],
          address: "Rua Cafezique, 78",
          phone: "912 345 680",
          socialMedia: {
            facebook: "https://www.facebook.com/Cafeziquept/?locale=pt_BR",
            instagram: "https://www.instagram.com/cafeziquept/",
            website: "https://www.cafezique.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3180.5625743653195!2d-8.026760923227188!3d37.13932057215254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab18b3c096f37%3A0x3d8742940db522f6!2zQ2Fmw6law69xdWU!5e0!3m2!1spt-PT!2spt!4v1748882784435!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Welcome Drink",
            description: ["Verre de vin mousseux"]
          },
          rootFolder: "CafeZique",
          images: ["0c8e01ad-d9ca-4b18-af60-26a700b19e31.avif", "b7455fd9-1912-4dc4-9d75-b6e3c18c21e1.avif", "c10b8475-9033-4f81-96a7-89723f3537a6.avif", "562a5999-384a-4fcf-876a-191a283c4417.avif", "1fc2a2ef-0625-4d3c-a43b-538301aad3c4.avif", "eb5af52c-c6c9-411a-87ba-578fa3de1e3f.avif", "47a07484-d88c-447f-91ed-4c7bf0a542c3.avif", "d59e735d-141e-4359-b024-3352c31e5b83.avif", "cff64c57-1e91-4133-a445-f033ab8f5838.avif", "98b3ee01-5726-41de-93f9-23ce6da1c1b7.avif"],
          menuUrl: "https://www.cafezique.pt/services"
        },
        {
          id: 5,
          name: "A ver Tavira",
          email: "restaurante@avertavira.pt",
          logo: "AverTavira.png",
          type: "Restaurant Gastronomique",
          description: "Le restaurant A Ver Tavira, récompensé d'une étoile Michelin, offre une expérience gastronomique unique au cœur historique de Tavira, avec des saveurs de l'Algarve et une vue imprenable. Sous la direction du chef Luís Brito, il allie tradition et créativité dans un menu innovant.",
          locationIds: [0],
          priceRange: 3,
          openingHours: [
            { day: "Lundi", hours: "Fermé" },
            { day: "Mardi", hours: "18:30 - 21:30" },
            { day: "Mercredi", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Jeudi", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Vendredi", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Samedi", hours: "12:00 - 14:30, 18:30 - 21:30" },
            { day: "Dimanche", hours: "Fermé" }
          ],
          address: "Rua de Tavira, 12",
          phone: "912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/avertavira.restaurante/",
            instagram: "https://www.instagram.com/avertavirarestaurante/",
            website: "https://avertavira.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.1350356455455!2d-7.653902723227645!3d37.125702272156204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd100379c4264773%3A0xca74ccd84b4f6fa!2sRestaurante%20A%20Ver%20Tavira!5e0!3m2!1spt-PT!2spt!4v1748882657083!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Verre de Bienvenue",
            description: ["Coupe de Champagne de Bienvenue"]
          },
          rootFolder: "A ver Tavira",
          images: [
            "borrego-feijao-bago-de.jpg",
            "rooftop-tavira.webp",
            "chefe-luis-brito.jpg",
            "cavala-marinada-e-gaspacho.jpg",
            "peixe-de-linha.jpg",
            "carabineiro-caril-couve.jpg",
            "the-detailed-combinations.jpg",
            "each-plate-prepared-with.jpg",
            "caption.jpg",
            "ce86969e3cec4b7bb0d0cde9e123fa0c.webp"
          ],
          menuUrl: "https://avertavira.com/menu/"
        },
        {
          id: 6,  
          name: "Tupuq",
          email: "reservas@tupuq.pt",
          logo: "Tupuqlogo.png",
          type: "Gastronomie Traditionnelle Portugaise",
          description: "Au cœur de l’Algarve, Tupuq est un restaurant chaleureux où la cuisine traditionnelle portugaise se réinvente avec une touche créative, le tout face à une vue imprenable sur l’océan.",
          locationIds: [4],
          priceRange: 2,
          openingHours: [
            { day: "Lundi", hours: "19:00 - 01:00" },
            { day: "Mardi", hours: "19:00 - 01:00" },
            { day: "Mercredi", hours: "19:00 - 01:00" },
            { day: "Jeudi", hours: "19:00 - 01:00" },
            { day: "Vendredi", hours: "19:00 - 01:00" },
            { day: "Samedi", hours: "19:00 - 01:00" },
            { day: "Dimanche", hours: "19:00 - 01:00" }
          ],
          address: "Rua Torre da Medronheira, Olhos d'Água,",
          phone: "927 131 868",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=61576808143494",
            instagram: "https://www.instagram.com/tupuq_restaurant/",
            website: "https://www.tupuq.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.6171226797!2d-8.197666523228731!3d37.09042497216555!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acbdfee471ee9%3A0x34d6eeb1f3250984!2sTupuq%20Restaurante%20%26%20Bar!5e0!3m2!1spt-PT!2spt!4v1751964426753!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "10% DE RÉDUCTION",
            description: ["10% DE RÉDUCTION"]
          },
          cardInfo: "Les réservations doivent être effectuées directement auprès de l'équipe Clever Details.",
          rootFolder: "Tupuq",
          images: [
            "TUPUQ 1.JPG",
            "TUPUQ 2.JPG",
            "TUPUQ 3.jpg",
            "TUPUQ 4.JPG",
            "TUPUQ 5.JPG",
            "TUPUQ 6.JPG",
            "TUPUQ 7.jpg",
            "TUPUQ 8.JPG",
            "TUPUQ 9.JPG",
            "TUPUQ 11.jpg",
            "TUPUQ 12.JPG"
          ],
          menuUrl: "https://www.tupuq.pt/menu"
        },
        {
          id: 7,  
          name: "Casa da Praia by Tupuq",
          email: "reservas@casadapraiabytupuq.pt",
          logo: "cdplogo.png",
          type: "Beach Club",
          description: "Casa da Praia est un refuge élégant et décontracté en bord de mer, où le temps ralentit, les saveurs s’éveillent et chaque instant se savoure au rythme de la mer et de l’été.",
          locationIds: [4],
          priceRange: 2,
          openingHours: [
                  { day: "Lundi", hours: "07:00 - 19:00" },
                  { day: "Mardi", hours: "07:00 - 19:00" },
                  { day: "Mercredi", hours: "07:00 - 19:00" },
                  { day: "Jeudi", hours: "07:00 - 19:00" },
                  { day: "Vendredi", hours: "07:00 - 19:00" },
                  { day: "Samedi", hours: "07:00 - 19:00" },
                  { day: "Dimanche", hours: "07:00 - 19:00" }
          ],
          address: "Rua Torre da Medronheira, Olhos d'Água,",
          phone: "927 131 869",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=61577093219124",
            instagram: "https://www.instagram.com/casadapraia_bytupuq/",
            website: "https://www.casadapraiabytupuq.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.6193988282516!2d-8.197668923228834!3d37.090370772165876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acb57c2e94b89%3A0x6281062a91947cb!2sCasa%20da%20Praia%20by%20Tupuq!5e0!3m2!1spt-PT!2spt!4v1751971364358!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "10% DE RÉDUCTION",
            description: ["10% DE RÉDUCTION"]
          },
          cardInfo: "Les réservations doivent être effectuées directement auprès de l'équipe Clever Details.",
          rootFolder: "Casa da Praia",
          images: [
           "CDP 1.JPG",
           "CDP 3.JPG",
           "CDP 4.JPG",
           "CDP 5.JPG",
           "CDP 6.JPG",
           "CDP 7.JPG",
           "CDP 8.JPG",
           "CDP 9.JPG",
           "CDP 10.JPG",
           "CDP 11.JPG",
           "CDP 12.JPG",
          ],
          menuUrl: "https://www.casadapraiabytupuq.com/menus"
        },
      ]
    },
    {
      id: "activities",
      title: "Activités",
      route: "/activities",
      description: "Profitez d'un accès exclusif aux activités premium",
      image: "card_slides.jpg",
      items: [
        {
          id: 1,
          name: "Family Golf Park",
          email: "info@familygolfpark.com",
          logo: "family-golf-park-logo-white.png",
          description: "Situé au cœur de Vilamoura, le Family Golf Park est un lieu incontournable pour les familles et les groupes à la recherche de divertissement et de loisir. Avec deux parcours de mini-golf thématiques inspirés de la Via Appia et de la Via Lusitânia, le parc offre une expérience unique au milieu de jardins luxurieux et d'architecture romaine. En outre, il dispose d'une zone de jeux pour les enfants, d'une salle de jeux, d'une bar-snack avec esplanade et même d'un train touristique qui passe par les points principaux de Vilamoura. Ouvert tous les jours, le Family Golf Park est parfait pour un jour de divertissement avec la famille.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "10:00 - 19:00" },
            { day: "Tuesday", hours: "10:00 - 19:00" },
            { day: "Wednesday", hours: "10:00 - 19:00" },
            { day: "Thursday", hours: "10:00 - 19:00" },
            { day: "Friday", hours: "10:00 - 19:00" },
            { day: "Saturday", hours: "10:00 - 19:00" },
            { day: "Sunday", hours: "10:00 - 19:00" }
          ],
          address: "Family Golf Park",
          phone: "+351 282 912 345",
          socialMedia: {
            facebook: "https://www.facebook.com/familygolfpark.pt",
            instagram: "https://www.instagram.com/familygolfpark/",
            website: "https://familygolfpark.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sFamily%20Golf%20Park!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "Family Golf Park",
          images: ["family-golf-park-gallery-05-min.jpg", "family-golf-park-gallery-10-min.jpg", "Legionario_2.webp", "Family-Golf-Park_2.webp", "Looping-Crazygolfe_2.webp", "family-golf-park.jpg", "lisbon-bridge.jpg", "relaxing-and-clever-minigolf.jpg", "vulcanos.jpg", "2sd-hole.jpg", "1st-hole.jpg", "welcome-to-the-best-europe.jpg"]
        },
        {
          id: 2,
          name: "Algarve Riders",
          email: "info@algarveriders.com",
          logo: "logo_algarveriders.png",
          description: "Algarve Riders est une entreprise de location de motos qui offre une expérience unique avec des motos de haute performance. C'est un endroit idéal pour profiter d'un après-midi de divertissement.",
          locationIds: [4],
          openingHours: [
            { day: "Monday", hours: "8:30 - 18:00" },
            { day: "Tuesday", hours: "8:30 - 18:00" },
            { day: "Wednesday", hours: "8:30 - 18:00" },
            { day: "Thursday", hours: "8:30 - 18:00" },
            { day: "Friday", hours: "8:30 - 18:00" },
            { day: "Saturday", hours: "8:30 - 18:00" },
            { day: "Sunday", hours: "8:30 - 18:00" }
          ],
          address: "Algarve Riders",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/algarveriders/?locale=pt_PT",
            instagram: "https://www.instagram.com/algarveriders/",
            website: "https://www.algarveriders.com/pt"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5144440743125!2d-8.241512908997843!3d37.09286990039514!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acc1c47179d53%3A0xae8f92aa7c2a4f1e!2sAlgarve%20Riders!5e0!3m2!1spt-PT!2spt!4v1748883603455!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION -Tours", "5% DE RÉDUCTION - Scooter"]
          },
          rootFolder: "Algarve Riders",
          images: ["algarve-riders-available.jpg", "algarve-riders-off-road (7).jpg", "algarve-riders-off-road (6).jpg", "algarve-riders-off-road (5).jpg", "algarve-riders-off-road (4).jpg", "algarve-riders-off-road (3).jpg", "algarve-riders-off-road (2).jpg", "algarve-riders-off-road (1).jpg", "algarve-quad-tours-fun.jpg", "team-building-buggy-tour.jpg", "algarve-riders-off-road.jpg"]
        },
        {
          id: 3,
          name: "Aia Racing School",
          email: "racingschool@autodromodoalgarve.com",
          logo: "Autódromo_Internacional_Algarve_logo.png",
          description: "Située sur l'Autodrome International de l'Algarve à Portimão, elle propose des expériences de conduite sportive dans des voitures haute performance comme Porsche, Mercedes et autres. Avec des instructeurs expérimentés et une infrastructure d'excellence, elle offre une immersion sûre et passionnante dans le monde du sport automobile.",
          locationIds: [6],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Mardi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Mercredi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Jeudi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Vendredi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Samedi", hours: "09:00 - 18:00 Sur rendez-vous" },
            { day: "Dimanche", hours: "09:00 - 18:00 Sur rendez-vous" }
          ],
          address: "Autódromo Internacional do Algarve",
          phone: "+351 282 405 600",
          socialMedia: {
            facebook: "https://www.facebook.com/AutodromoInternacionaldoAlgarve",
            instagram: "https://www.instagram.com/autodromodoalgarve/",
            website: "https://autodromodoalgarve.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.675044142391!2d-8.231442223228038!3d37.11285207215955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acf3201d06d49%3A0xa8045a2667997fdb!2sAut%C3%B3dromo%20Internacional%20do%20Algarve!5e0!3m2!1spt-PT!2spt!4v1748882885204!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["5 % de réduction"]
          },
          rootFolder: "Aia Racing School",
          images: [
            "295303780_10159273014723531_8030419394435337216_n.jpg",
            "racing-school.jpg",
            "AIA-Classe-A-AMG-9-scaled.jpg",
            "AIA-AMG-GT-Preto-27-scaled-e1744045842936.jpg",
            "Davanti-AIA-Racing-School.jpg",
            "NunOrganistA_048a.jpg",
            "parceiro_70_racing_school_cf026414_3__2___1_tonemapped2b_1__2.jpg"
          ]
        },
        {
          id: 4,
          name: "Karting Portimão",
          email: "kia@parkalgar.com",
          logo: "Kartodromoalgarve.png",
          description: "Le Karting International de l'Algarve, à Portimão, est l'un des plus grands circuits de karting d'Europe, avec 1.531 km de longueur. Il offre des expériences pour toutes les âges, des enfants aux adultes, avec des karts adaptés à différents groupes d'âge et niveaux d'expérience. En plus d'être un lieu pour les compétitions officielles et les événements privés, il dispose d'une infrastructure complète, y compris un restaurant, des boxes et des boutiques.",
          locationIds: [6],
          openingHours: [
            { day: "Monday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Tuesday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Wednesday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Thursday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Friday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Saturday", hours: "09:00 - 13:00, 14:00 - 17:30" },
            { day: "Sunday", hours: "09:00 - 13:00, 14:00 - 17:30" }
          ],
          address: "Parkalgar, Portimão",
          phone: "+351 282 405 650",
          socialMedia: {
            facebook: "https://www.facebook.com/kartodromo.algarve",
            instagram: "https://www.instagram.com/kartodromodoalgarve/",
            website: "https://autodromodoalgarve.com/pt/the-park/kartodromo/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3176.658452607274!2d-8.638724023223917!3d37.23208217212703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1b2498b60682cb%3A0xa6b4e4ed93bd2a1e!2sKart%C3%B3dromo%20Internacional%20do%20Algarve!5e0!3m2!1spt-PT!2spt!4v1748882967187!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "KartingPortimao",
          images: ["39129269_2071071279603968_9122454272632422400_n.jpg", "Kartodromo2-scaled.jpg", "490851637_1218406543617808_2741633398730202739_n.jpg", "488211910_1210059391119190_5497740365812582147_n.jpg", "489446312_1210956781029451_2393478272773825535_n.jpg", "kartodromo6-pqchj12nib2vumiq0zqzcru0robuxlzilx7rhu5n6o.jpg", "kartodromo3-pqchj12nib2vumiq0zqzcru0robuxlzilx7rhu5n6o.jpg", "490229418_1218688256922970_8436650453256995830_n.jpg", "IMG_2422.jpg"]
        },
        {
          id: 5,
          name: "Slide & Splash",
          email: "info@slidesplash.com",
          logo: "logo_slidesplash.png",
          description: "Le Slide & Splash, à Lagoa, est un parc aquatique familial avec diverses attractions pour tous les âges. En plus des toboggans excitants, il propose des zones pour enfants, des espaces de détente et des spectacles d'animaux. Idéal pour une journée de divertissement en Algarve.\n\nHoraires Saisonniers:\n- Juin: 10:00 - 17:30\n- 1 Juillet au 12 Septembre: 10:00 - 18:00\n- 13 Septembre au 31 Octobre: 10:00 - 17:00",
          locationIds: [7],
          openingHours: [
            { day: "Lundi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Mardi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Mercredi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Jeudi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Vendredi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Samedi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Dimanche", hours: "10:00 - 18:00 (horaires variables selon la saison)" }
          ],
          address: "Vale de Deus, 8401-901 Estombar, Lagoa",
          phone: "+351 282 340 800",
          socialMedia: {
            facebook: "https://www.facebook.com/slidesplash",
            instagram: "https://www.instagram.com/slidesplash",
            website: "https://www.slidesplash.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4178.596435740619!2d-8.477506287857912!3d37.13992344835856!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad7dcb0aff5c5%3A0xbe389806c01894c5!2sSlide%20%26%20Splash!5e1!3m2!1spt-PT!2spt!4v1774626000023!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["12% DE RÉDUCTION"]
          },
          rootFolder: "Slide&Splash",
          images: ["Slide-Splash-Torre-sector-4-e-aereas_3-e1679392334545.webp", "atracoes31.jpg", "Slide-Splash-Water-Park-Algarve-Portugal.jpg", "atracoes39.jpg", "slide-splash-water-slide.jpg", "new-ride-2018-disco-river.jpg", "new-rides-2018.jpg", "black-hole.jpg", "slide-splash-2019 (1).jpg", "the-big-wave.jpg", "big-slides-tower.jpg", "slide-splash-2019.jpg", "slide-2020.jpg"]
        },
        {
          id: 6,
          name: "Zoomarine",
          email: "info@zoomarine.pt",
          logo: "logozoomarine.png",
          description: "Zoomarine, situé près d'Albufeira, est un parc thématique qui combine divertissement, éducation et nature. Avec des spectacles de dauphins, des lions-marins, des oiseaux tropicaux, des toboggans d'eau et une plage artificielle, c'est parfait pour un jour inoubliable avec la famille. Une aventure magique au cœur de l'Algarve!\n\nHoraires Saisonniers:\n- Mars, Octobre, Novembre: 10:00 - 17:00\n- Avril à 22 Juin et Septembre 10 à 28: 10:00 - 18:00\n- 23 Juin à 7 Septembre: 10:00 - 19:30",
          locationIds: [4],
          openingHours: [
            { day: "Monday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Tuesday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Wednesday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Thursday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Friday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Saturday", hours: "10:00 - 19:30 (horário varia por época)" },
            { day: "Sunday", hours: "10:00 - 19:30 (horário varia por época)" }
          ],
          address: "EN 125, Km 65, 8201-864 Guia, Albufeira",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/ZoomarineAlgarve/?locale=pt_PT",
            instagram: "https://www.instagram.com/zoomarine_algarve_oficial/",
            website: "https://www.zoomarine.pt/pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.16183350874!2d-8.317631323227639!3d37.12506467215641!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ace4ed8ed7ec7%3A0x8cf7b5092d8538af!2sZoomarine%20Algarve!5e0!3m2!1spt-PT!2spt!4v1748883516694!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["-3,5€ Normal", "-2,5€ Sénior/Júnior", "-12€ Dolphin Emotions"]
          },
          rootFolder: "Zoomarine",
          images: ["145.jpg", "145 (1).jpg", "145 (2).jpg", "145 (3).jpg", "145 (4).jpg", "145 (5).jpg", "145 (6).jpg", "145 (7).jpg", "145 (8).jpg", "145 (9).jpg", "145 (10).jpg", "image_processing20240617-9-uc4gqx.jpg", "Zoomarine_2.jpg", "zoomarine.jpg"],
        },
        {
          id: 7,
          name: "Aquashow",
          email: "info@aquashow.com",
          logo: "aquashow_logo.png",
          description: "Aquashow Outdoor est le plus grand parc aquatique en plein air de Portugal, situé au cœur de l'Algarve. Avec des toboggans géants, une piscine à vagues, des attractions pour toutes les âges et beaucoup d'animation, c'est le lieu idéal pour un jour d'été plein de divertissement, d'adrénaline et de souvenirs familiaux ou entre amis.",
          locationIds: [8],
          openingHours: [
            { day: "Monday", hours: "10:00 - 18:00" },
            { day: "Tuesday", hours: "10:00 - 18:00" },
            { day: "Wednesday", hours: "10:00 - 18:00" },
            { day: "Thursday", hours: "10:00 - 18:00" },
            { day: "Friday", hours: "10:00 - 18:00" },
            { day: "Saturday", hours: "10:00 - 18:00" },
            { day: "Sunday", hours: "10:00 - 18:00" }
          ],
          address: "Aquashow",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/AquashowParque/?locale=pt_PT",
            instagram: "https://www.instagram.com/aquashowparkhotel/",
            website: "https://aquashowpark.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5023582651565!2d-8.074484223228705!3d37.09315767216503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab575a4f4c3dd%3A0xfddc87f54582acc1!2sAQUASHOW%20-%20Waterpark%20Outdoor%20%26%20Indoor!5e0!3m2!1spt-PT!2spt!4v1748883493782!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "Aquashow",
          images: ["IMG_2075.jpg", "Galeria-03.jpg", "aquashow-park (6).jpg", "air-race.jpg", "aquashow-park (5).jpg", "aquashow-park (4).jpg", "aquashow-park (3).jpg", "aquashow-park (2).jpg", "aquashow-park (1).jpg", "aquashow-park.jpg"]
        },
         {
          id: 8,
          name: "Aqualand Algarve",
          email: "aqualandalgarve@asproparks.com",
          logo: "aqualand.webp",
          description: "Aqualand Algarve est l'un des plus grands parcs aquatiques du pays, avec des zones adaptées aux familles, des espaces pour les plus petits et des endroits relaxants pour recharger les batteries. Entre éclaboussures, piscines à vagues et rivières tranquilles, c'est la destination idéale pour une journée complète de divertissement en famille.",
          locationIds: [9],
          openingHours: [
                { day: "Lundi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Mardi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Mercredi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Jeudi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Vendredi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Samedi", hours: "10:00 - 18:00 (horaires variables selon la saison)" },
            { day: "Dimanche", hours: "10:00 - 18:00 (horaires variables selon la saison)" }
          ],
          address: "Aqualand Algarve",
          phone: "+351 282 320 230",
          socialMedia: {
            facebook: "https://www.facebook.com/aqualandalgarve",
            instagram: "https://www.instagram.com/aqualandalgarveoficial/",
            website: "https://www.aqualand.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d101808.49895831558!2d-8.355817944620606!3d37.116646827524605!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad0e39d6bfd4b%3A0x81a56dd58df0e845!2sAqualand%20Algarve!5e0!3m2!1spt-PT!2spt!4v1749485410610!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["9€ de Réduction: Billet Adulte"]
          },
          rootFolder: "aqualand",
          images: ["ALG-Banzai-1-1-scaled.webp", "ALG-Kamikaze-scaled.webp", "ALG-rapids-scaled.webp", "Hydra-scaled.webp", "atracciones-1-scaled-w.webp", "banner-atracciones-1-w-1.webp", "hydra.jpg", "king-cobra.jpg", "plano-parque-scaled.webp"]
        },
        {
          id: 9,
          name: "Aquashow Indoor",
          email: "info@aquashow.com",
          logo: "aquashow_logo.png",
          description: "Le premier et unique parc aquatique couvert de la péninsule ibérique, avec air et eau chauffés. Piscines de détente, jacuzzis, toboggans aquatiques, piscine à vagues, espace enfants et une zone SPA exclusive réservée aux plus de 13 ans. Une expérience unique au Portugal pour toute la famille.",
          locationIds: [8],
          openingHours: [
            { day: "Lundi", hours: "10:00 - 18:15" },
            { day: "Mardi", hours: "10:00 - 18:15" },
            { day: "Mercredi", hours: "10:00 - 18:15" },
            { day: "Jeudi", hours: "10:00 - 18:15" },
            { day: "Vendredi", hours: "10:00 - 18:15" },
            { day: "Samedi", hours: "10:00 - 18:15" },
            { day: "Dimanche", hours: "10:00 - 18:15" }
          ],
          address: "Aquashow",
          phone: "+351 289 560 300",
          socialMedia: {
            facebook: "https://www.facebook.com/AquashowParque/?locale=pt_PT",
            instagram: "https://www.instagram.com/aquashowparkhotel/",
            website: "https://aquashowpark.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3182.5023582651565!2d-8.074484223228705!3d37.09315767216503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab575a4f4c3dd%3A0xfddc87f54582acc1!2sAQUASHOW%20-%20Waterpark%20Outdoor%20%26%20Indoor!5e0!3m2!1spt-PT!2spt!4v1748883493782!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "indoor",
          images: ["indoor1.jpg", "indoor2.jpg", "indoor3.jpg", "indoor4.jpg", "indoor5.jpg", "indoor6.jpg", "indoor7.jpg", "indoor8.jpg", "indoor9.jpg"]
        },
        {
          id: 999,
          name: "Golf",
          email: "info@specialactivity.com",
          logo: "teetimesgolf.png",
          description: "L'agence Tee Times Golf a été créée il y a plus de 20 ans par Carlos Ferreira, associé-gérant, et a depuis parcouru un long chemin. Aujourd'hui, Tee Times est l'un des plus grands opérateurs spécialisés en golf de l'Algarve.",
          locationIds: [3],
          isVisible: false, // Hidden from advantages page, shown on homepage
          openingHours: [
            { day: "Lundi", hours: "09:00 - 17:00" },
            { day: "Mardi", hours: "09:00 - 17:00" },
            { day: "Mercredi", hours: "09:00 - 17:00" },
            { day: "Jeudi", hours: "09:00 - 17:00" },
            { day: "Vendredi", hours: "09:00 - 17:00" },
            { day: "Samedi", hours: "10:00 - 16:00" },
            { day: "Dimanche", hours: "10:00 - 16:00" }
          ],
          address: "Vilamoura",
          phone: "+351 123 456 789",
          socialMedia: {
            facebook: "https://www.facebook.com/specialactivity",
            instagram: "https://www.instagram.com/specialactivity/",
            website: "https://www.specialactivity.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3183.1293522678575!2d-8.12651112322924!3d37.07822597216927!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab5921a12b7dd%3A0x8c7a9a7499808406!2sVilamoura!5e0!3m2!1spt-PT!2spt!4v1748883359829!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Offre Spéciale",
            description: ["Cliquez pour visiter notre site web"]
          },
          rootFolder: "TeeTimes",
          images: ["golf-ball-3638706.jpg"],
          redirectUrl: "http://onlinebooking.tee-times.info/affiliates.php?key=60e3cf13ac20c3bda7912ef38d45ad67&region=2"
        }
      ]
    },
    {
      id: "rent-a-car",
      title: "Rent a Car",
      route: "/rent-a-car",
      description: "Location de voitures dans tout l'Algarve à des tarifs compétitifs",
      image: "person-preparing-get-driver-license.jpg",
      items: [
        {
          id: 1,
          name: "Movida Rent a Car",
          email: "reservas@driveonholidays.com",
          logo: "cdplogo.png",
          description: "Movida Rent a Car est un partenaire de confiance dans la location de véhicules au Portugal, présent dans les principaux aéroports et disposant d’une flotte moderne, variée et constamment renouvelée. Elle offre un service simple, rapide et flexible, avec kilométrage illimité et un haut niveau de qualité de service. Les clients Clever Details bénéficient de 5 % de réduction sur la location. Pour en profiter, il suffit d’accéder via le lien fourni ou d’utiliser le code CLEVERDETAILS. Il est également possible de demander la livraison du véhicule directement à la propriété, moyennant des frais de service de 40 €, pour un maximum de confort pendant votre séjour.",
          locationIds: [5],
          openingHours: [
            { day: "Lundi", hours: "08:00 - 20:00" },
            { day: "Mardi", hours: "08:00 - 20:00" },
            { day: "Mercredi", hours: "08:00 - 20:00" },
            { day: "Jeudi", hours: "08:00 - 20:00" },
            { day: "Vendredi", hours: "08:00 - 20:00" },
            { day: "Samedi", hours: "08:00 - 20:00" },
            { day: "Dimanche", hours: "08:00 - 20:00" }
          ],
          address: "Faro",
          phone: "+351 212 697 488",
          socialMedia: {
            facebook: "https://www.facebook.com/movidarentacarpt/",
            instagram: "https://www.instagram.com/movidarentacarpt/",
            website: "http://www.movidarentacar.pt/pt/home?voucher=CLEVERDETAILS"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3185.1537749304584!2d-7.964972187702315!3d37.02997967206658!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab2ab2cac0965%3A0xbf36117f6d51fa80!2sMovida%20Rent%20a%20Car%20-%20Faro%20Aeroporto!5e0!3m2!1spt-PT!2spt!4v1776080620743!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["5% DE RÉDUCTION"]
          },
          rootFolder: "movida",
          images: ["person-preparing-get-driver-license.jpg"]
        }
      ]
    },
    {
      id: "winery-tours",
      title: "Visites de Caves",
      route: "/winery-tours",
      description: "Découvrez les meilleurs vins de la région",
      image: "vertical-shot-person-holding-glass-wine-vineyard-sunlight.jpg",
      items: [
        {
          id: 1,
          name: "Quinta do Canhoto",
          email: "info@quintadocanhoto.com",
          logo: "LOGO_QDC_WHITE_NEW.png",
          description: "La Quinta do Canhoto, à Albufeira, est une référence en matière de vins de l'Algarve, alliant tradition familiale et innovation. Elle propose des dégustations de vins et des expériences uniques d'œnotourisme. Les visites doivent être réservées 24h à l'avance.",
          locationIds: [4],
          openingHours: [
            { day: "Lundi", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Mardi", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Mercredi", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Jeudi", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Vendredi", hours: "11:00 - 13:00, 14:30 - 18:30" },
            { day: "Samedi", hours: "Fermé" },
            { day: "Dimanche", hours: "Fermé" }
          ],
          address: "Quinta do Canhoto",
          phone: "+351 912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/p/Quinta-do-Canhoto-100049285896978/",
            instagram: "https://www.instagram.com/quinta_do_canhoto/",
            website: "https://www.quintadocanhoto.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.675044142391!2d-8.231442223228038!3d37.11285207215955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acf3201d06d49%3A0xa8045a2667997fdb!2sQuinta%20do%20Canhoto%20Adega!5e0!3m2!1spt-PT!2spt!4v1748882885204!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Réduction",
            description: ["5% DE RÉDUCTION"]
          },
          rootFolder: "Quinta do Canhoto",
          images: ["almoco-vinico.jpg", "as-vinhas.jpg", "espaco-exterior.jpg", "provas-de-vinho.jpg", "o-deck-da-adega.jpg", "great-day-out-lovely.jpg", "caption.jpg", "great-day-out-lovely (1).jpg", "great-day-out-lovely (2).jpg"]
        },
        {
          id: 2,
          name: "Morgado do Quintão",
          email: "info@morgadodoquintao.pt",
          logo: "Morgado do quintao.png",
          description: "Le Morgado do Quintão, à Lagoa, combine tradition et durabilité dans la production de vins authentiques. Il propose des dégustations de vins et des expériences uniques dans le domaine de l'enotourisme.",
          locationIds: [7],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 22:00" },
            { day: "Mardi", hours: "09:00 - 22:00" },
            { day: "Mercredi", hours: "09:00 - 22:00" },
            { day: "Jeudi", hours: "09:00 - 22:00" },
            { day: "Vendredi", hours: "09:00 - 22:00" },
            { day: "Samedi", hours: "09:00 - 22:00" },
            { day: "Dimanche", hours: "Closed" }
          ],
          address: "Morgado do Quintão",
          phone: "+351 282 912 345",
          socialMedia: {
            facebook: "https://www.facebook.com/morgadoquintao/",
            instagram: "https://www.instagram.com/morgadodoquintao/",
            website: "https://www.morgadodoquintao.pt/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3179.790358516998!2d-8.4519159232265!3d37.157684072147326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ad78519c4f4e1%3A0xe72edb7d0b164be9!2sMorgado%20do%20Quint%C3%A3o!5e0!3m2!1spt-PT!2spt!4v1748882911445!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["15% DE RÉDUCTION"]
          },
          rootFolder: "MorgadodoQuintao",
          images: ["a-beautiful-plate-to.jpg", "morgado-do-quintao.jpg", "there-is-nothing-like.jpg", "wine-tasting-in-an-old.jpg", "palhete-our-best-selling.jpg", "typical-carapaus-alimados.jpg", "photo0jpg.jpg", "caption.jpg", "palhete-our-best-selling (1).jpg"]
        },
        {
          id: 3,
          name: "Adega do Cantor",
          email: "info@adegadocantor.com",
          logo: "adega-do-cantor.png",
          description: "L'Adega do Cantor, propriété du célèbre chanteur Sir Cliff Richard, produit des vins primés comme le Vida Nova. Elle propose des visites guidées des vignobles et de la cave, avec des dégustations de vins et des expériences gastronomiques uniques.",
          locationIds: [4],
          openingHours: [
            { day: "Lundi", hours: "10:00 - 17:00" },
            { day: "Mardi", hours: "10:00 - 17:00" },
            { day: "Mercredi", hours: "10:00 - 17:00" },
            { day: "Jeudi", hours: "10:00 - 17:00" },
            { day: "Vendredi", hours: "10:00 - 17:00" },
            { day: "Samedi", hours: "Fermé" },
            { day: "Dimanche", hours: "Fermé" }
          ],
          address: "Adega do Cantor",
          phone: "+351 912 345 679",
          socialMedia: {
            facebook: "https://www.facebook.com/adegadocantor",
            instagram: "https://www.instagram.com/adegadocantor",
            website: "https://www.adegadocantor.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.675044142391!2d-8.231442223228038!3d37.11285207215955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acf3201d06d49%3A0xa8045a2667997fdb!2sAdega%20do%20Cantor!5e0!3m2!1spt-PT!2spt!4v1748882885204!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Expérience Premium",
            description: ["5 % de réduction"]
          },
          rootFolder: "Adega do Cantor",
          images: [
            "photo4jpg.jpg",
            "photo5jpg.jpg",
            "photo2jpg (1).jpg",
            "photo4jpg (1).jpg",
            "photo0jpg.jpg",
            "photo3jpg.jpg",
            "photo0jpg (1).jpg",
            "img-20190507-145609-largejpg.jpg",
            "img-20190507-142303-largejpg.jpg",
            "beautiful-cellar.jpg",
            "photo3jpg (1).jpg",
            "photo2jpg.jpg",
            "20181004-154037-largejpg.jpg"
          ]
        }
      ]
    },
    {
      id: "wellness",
      title: "Bien-être",
      route: "/wellness",
      description: "Détendez-vous et ressourcez-vous avec nos partenaires bien-être",
      image: "close-up-therapist-hand-massaging-woman-s-back-with-hot-towel-spa.jpg",
      items: [
        {
          id: 1,
          name: "7 Seven Spa Vilamoura",
          email: "7 Seven Spa Vilamoura@cleverdetails.com",
          logo: "7spa.svg",
          description: "Le 7 Seven Spa, situé au Hilton Vilamoura As Cascatas Golf Resort & Spa, offre une expérience bien-être avec 14 salles de soins, un circuit d'hydrothérapie, sauna, hammam, jacuzzi et jardin zen. Idéal pour se détendre et se ressourcer.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "09:45 - 21:00" },
            { day: "Mardi", hours: "09:45 - 21:00" },
            { day: "Mercredi", hours: "09:45 - 21:00" },
            { day: "Jeudi", hours: "09:45 - 21:00" },
            { day: "Vendredi", hours: "09:45 - 21:00" },
            { day: "Samedi", hours: "09:45 - 20:00" },
            { day: "Dimanche", hours: "09:45 - 20:00" }
          ],
          address: "Rua das oliveiras",
          phone: "912 345 678",
          socialMedia: {
            facebook: "https://www.facebook.com/7SevenSpaVilamoura",
            instagram: "https://www.instagram.com/7_spa_vilamoura/",
            website: "https://www.hilton.com/pt/hotels/faohihi-hilton-vilamoura-as-cascatas-golf-resort-and-spa/spa/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.675044142391!2d-8.231442223228038!3d37.11285207215955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1acf3201d06d49%3A0xa8045a2667997fdb!2s7%20Seven%20Spa%20Vilamoura!5e0!3m2!1spt-PT!2spt!4v1748882885204!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Offre Spéciale",
            description: ["15% DE RÉDUCTION sur le Menu", "€5 DE RÉDUCTION sur le Circuit Thérapeutique"]
          },
          rootFolder: "7 Seven Spa Vilamoura",
          images: [
            "7-Seven-Spa_-scaled.jpg",
            "7Spa6.jpg",
            "7spa-01.jpg",
            "7spa-02.jpg",
            "FAO_70271_Hilton_Vilamoura_Golf_Resort_&_Spa_0623_07.jpg",
            "7-seven-spa-hilton-vilamoura-bem-estar-algarve_F.webp",
            "faohi-spa19-hilton-vilamoura.avif",
            "faohi-spa25-hilton-vilamoura.avif",
            "faohi-spa28-hilton-vilamoura.avif",
            "faohi-spa11-hilton-vilamoura.avif",
            "faohi-spa21-hilton-vilamoura.avif"
          ]
        },
        {
          id: 2,
          name: "Duo Spa & Life Care",
          email: "info@duospa.com",
          logo: "DuoSpacare.png",
          description: "Le Duo Spa & Life Care, situé au Cegonha Country Club à Vilamoura, propose des expériences bien-être avec circuit spa, sauna, hammam et soins comme l'exfoliation ou l'Iyashi Dome, pour des moments de détente et de rajeunissement.",
          cardInfo:"Vous devez présenter votre carte de membre à votre arrivée.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Mardi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Mercredi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Jeudi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Vendredi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Samedi", hours: "10:00 - 13:00, 14:30 - 19:00" },
            { day: "Dimanche", hours: "Fermé" }
          ],
          address: "Vilamoura",
          phone: "+351 282 000 000",
          socialMedia: {
            facebook: "https://www.facebook.com/profile.php?id=100092450604778",
            instagram: "https://www.instagram.com/duospalifecare/",
            website: "https://duospalifecare.com/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3181.683821499002!2d-8.153268823228066!3d37.11264317215962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ac975c94113ab%3A0xcc82fe0af660f648!2sDuoSpa%20%26%20Life%20Care!5e0!3m2!1spt-PT!2spt!4v1748882994473!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Pack Premium",
            description: ["20% DE RÉDUCTION sur le Soin Premium", "€5 DE RÉDUCTION sur le Menu", "Accès au Circuit Détox..."]
          },
          rootFolder: "Duo Spa & Life Care",
          images: [
            "474105319_527080770383605_5631574254499945256_n.jpg",
            "474381410_527080747050274_4179998407528808811_n.jpg",
            "479886329_544365938655088_6110947825713535078_n.jpg",
            "IMG_1721-1024x683.jpg",
            "piscina-interior-duo-spa-life-care-cegonha-country-club-quarteira-algarve_F.jpg",
            "Captura de ecrã 2025-05-27, às 10.50.39.png",
            "Captura de ecrã 2025-05-27, às 10.46.17.png"
          ]
        },
          {
          id: 3,
          name: "Soultice Wellness",
          email: "soulticewellness@gmail.com",
          logo: "Soultice.png",
          description: "Soultice Wellness propose des expériences de bien-être personnalisées directement dans votre lieu de vacances. Des massages, des thérapies alternatives, du yoga, de la nutrition et des pratiques de relaxation, tout est conçu pour votre confort et votre équilibre. Service à domicile disponible avec des frais de déplacement de 10 €. Réservation préalable obligatoire (minimum 24h). Prenez soin de vous, sans quitter votre logement.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "09:00 - 19:00" },
            { day: "Mardi", hours: "09:00 - 19:00" },
            { day: "Mercredi", hours: "09:00 - 19:00" },
            { day: "Jeudi", hours: "09:00 - 19:00" },
            { day: "Vendredi", hours: "09:00 - 19:00" },
            { day: "Samedi", hours: "09:00 - 19:00" },
            { day: "Dimanche", hours: "09:00 - 19:00" }

          ],
          address: "Vilamoura",
          phone: "+351 917 681 352",
          socialMedia: {
            facebook: "",
            instagram: "https://www.instagram.com/soulticewellness/",
            website: ""
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3681.9198740027814!2d-8.090034891845523!3d37.077583268245405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab449928ec0a3%3A0xd20db14251c8033e!2sVila%20Sol%20Shopping%20Center!5e0!3m2!1spt-PT!2spt!4v1753105634800!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["20% de RÉDUCTION"]
          },
          rootFolder: "Soultice Wellness",
          images: [
            "Soultice 1.jpg",
            "Soultice 2.jpg",
            "Soultice 3.jpg",
            "Soultice 4.jpg",
            "Soultice 5.png",
          ]
        },
        {
          id: 4,
          name: "DMed Clinic",
          email: "info@dmedclinic.com",
          logo: "DmedClinic.png",
          description: "La DMed Clinic propose des services médicaux à domicile dans toute la région, incluant des consultations de Médecine Générale, Psychologie, Nutrition, Psychiatrie et Télémédecine, évitant les déplacements inutiles.",
          cardInfo:"Pour toute assistance médicale, veuillez contacter directement la clinique DMed au +351 916 546 408 et indiquer que vous êtes client de Clever Details.",
          locationIds: [3],
          openingHours: [
            { day: "Lundi", hours: "24h" },
            { day: "Mardi", hours: "24h" },
            { day: "Mercredi", hours: "24h" },
            { day: "Jeudi", hours: "24h" },
            { day: "Vendredi", hours: "24h" },
            { day: "Samedi", hours: "24h" },
            { day: "Dimanche", hours: "24h" }
          ],
          address: "DMed Clinic",
          phone: "+351 282 000 000",
          socialMedia: {
            facebook: "https://www.facebook.com/dmedclinic",
            instagram: "https://www.instagram.com/dmedclinic",
            website: "https://www.dmedclinic.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.123456!3d37.134567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          rootFolder: "DmedClinic",
          images: [
            "468288652_122196529190067954_5219035909363135589_n.jpg",
            "382379297_6903254336363281_5117175850526879907_n.jpg",
            "468219820_122196529196067954_5403389782633898697_n.jpg"
          ]
        }
      ]
    },
    {
      id: "beauty-and-hair-salons",
      title: "Salons de Beauté",
      route: "/beauty-and-hair-salons",
      description: "Prenez soin de votre beauté avec les meilleurs professionnels",
      image: "pexels-valeriya-939836.jpg",
      items: [
        {
          id: 2,
          name: "Matilde",
          email: "teresa.estetica@live.com.pt",
          logo: "matildelogo2.png",
          description: "Le salon Matilde Alves à Vilamoura propose un service de qualité et des résultats magnifiques. Situé sur l’Avenue Tivoli, en face de l’Hôtel Dom Pedro, il est reconnu pour son savoir-faire et son accueil chaleureux.",
          locationIds: [3],
          openingHours: [
            { day: "Monday", hours: "Fermé" },
            { day: "Tuesday", hours: "09:00 - 19:00" },
            { day: "Wednesday", hours: "09:00 - 19:00" },
            { day: "Thursday", hours: "09:00 - 19:00" },
            { day: "Friday", hours: "09:00 - 19:00" },
            { day: "Saturday", hours: "09:00 - 19:00" },
            { day: "Sunday", hours: "Fermé" }
          ],
          address: "Vilamoura",
          phone: "+351 289 302 807",
          socialMedia: {
            facebook: "https://www.facebook.com/MatildeCabeleireiroVilamoura",
            instagram: "https://www.instagram.com/matilde_cabeleireiro/",
            website: "https://quarteira.empresasportugal.net/hair-care/matilde-cabeleireiro/"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6366.490908187981!2d-8.117661923229319!3d37.07546047216995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd1ab597022a1131%3A0x6f4e5cea9d557db8!2sMatilde%20Cabeleireiro%20(%20vilamoura%20Portugal%20)!5e0!3m2!1spt-PT!2spt!4v1750672594399!5m2!1spt-PT!2spt",
          specialOffer: {
            type: "Discount",
            description: ["10% DE RÉDUCTION"]
          },
          rootFolder: "Matilde",
         images: ["matilde1.webp", "matilde2.webp", "matilde3.webp", "matilde4.webp", "matilde5.webp", "matilde6.webp", "matilde7.webp", "matilde8.webp", "matilde9.webp"],
        }

      ]
    },
    {
      id: "chef-at-home",
      title: "Chef à Domicile",
      route: "/chef-at-home",
      description: "Profitez d'une expérience gastronomique unique dans le confort de votre maison",
      image: "professional-chef-preparing-food-kitchen.jpg",
      items: [
        {
          id: 1,
          name: "Chef André Simão",
          email: "asimao2@hotmail.com",
          logo: "teste",
          description: "Chef executivo de cozinha do Monte Rei onde se encontra o restaurante recomendado pelo guia Michelin, Vistas Monte Rei. Proporciona estilos de cozinha descontraídos, para juntar amigos e familia à mesa com menus de tapas & drinks, barbecue, menu algarvio ou menu de degustação em 5 momentos para celebrações mais pormenorizadas.",
          locationIds: [],
          openingHours: [
            { day: "Monday", hours: "By appointment" },
            { day: "Tuesday", hours: "By appointment" },
            { day: "Wednesday", hours: "By appointment" },
            { day: "Thursday", hours: "By appointment" },
            { day: "Friday", hours: "By appointment" },
            { day: "Saturday", hours: "By appointment" },
            { day: "Sunday", hours: "By appointment" }
          ],
          address: "Service at your location",
          phone: "9251500",
          socialMedia: {
            facebook: "https://www.facebook.com/chefandresimao",
            instagram: "https://www.instagram.com/chefandresimao",
            website: "https://www.chefandresimao.pt"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.178901!3d37.112345!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Welcome Package",
            description: ["Vin de Porto et douceurs traditionnelles de l'Algarve"]
          },
          rootFolder: "ChefAndreSimao",
          images: ["Captura de ecrã 2025-05-30, às 14.00.44.png", "Captura de ecrã 2025-05-30, às 14.01.45.png", "Captura de ecrã 2025-05-30, às 14.01.52.png", "Captura de ecrã 2025-05-30, às 14.01.18.png", "Captura de ecrã 2025-05-30, às 14.01.05.png", "Captura de ecrã 2025-05-30, às 14.02.12.png", "Captura de ecrã 2025-05-30, às 14.02.29.png", "Captura de ecrã 2025-05-30, às 14.00.58.png"]
        },
        {
          id: 2,
          name: "Fancy Kitchen Algarve",
          email: "info@fancykitchenalgarve.com",
          logo: "Fancy kitchen.webp",
          description: "A Fancy Kitchen Algarve oferece experiências gastronómicas exclusivas com chefs privados e catering personalizado, elevando cada momento com requinte e sabor.",
          locationIds: [],
          openingHours: [
            { day: "Monday", hours: "By appointment" },
            { day: "Tuesday", hours: "By appointment" },
            { day: "Wednesday", hours: "By appointment" },
            { day: "Thursday", hours: "By appointment" },
            { day: "Friday", hours: "By appointment" },
            { day: "Saturday", hours: "By appointment" },
            { day: "Sunday", hours: "By appointment" }
          ],
          address: "Service at your location",
          phone: "912 345 681",
          socialMedia: {
            facebook: "https://www.facebook.com/fancykitchen",
            instagram: "https://www.instagram.com/fancykitchen",
            website: "https://www.fancykitchenalgarve.com"
          },
          mapsUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3125.835434509374!2d-8.142345!3d37.087654!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0!2s!5e0!3m2!1sen!2spt!4v1616581234567!5m2!1sen!2spt",
          specialOffer: {
            type: "Welcome Package",
            description: ["Verre de vin mousseux et 2 canapés par personne"]
          },
          rootFolder: "Fancy Kitchen",
          images: [
            "rs=w_700,cg_true,m.webp",
            "rs=w_800,cg_true,m.webp",
            "rs=w_612,cg_true,m.webp",
            "rs=w_1200,cg_true,m (2).webp",
            "rs=w_1200,cg_true,m (3).webp",
            "rs=w_1200,cg_true,m.webp",
            "rs=w_1200,cg_true,m (1).webp"
          ]
        }
      ]
    }
  ],
  locations: [
    {
      id: 0,
      name: "Tavira",
      image: "/location1.jpg",
      description: "Ville côtière historique connue pour son pont romain, ses ruines de château et ses belles plages accessibles en bateau.",
    },
    {
      id: 1,
      name: "Quinta do Lago",
      image: "/location2.jpg",
      description: "Station balnéaire de luxe avec des parcours de golf de classe mondiale, une cuisine raffinée et des plages immaculées.",
    },
    {
      id: 2,
      name: "Loulé",
      image: "/location3.jpg",
      description: "Ville de marché traditionnelle célèbre pour son bâtiment de marché historique et son atmosphère portugaise authentique.",
    },
    {
      id: 3,
      name: "Vilamoura",
      image: "/location4.jpg",
      description: "Ville marina moderne offrant des yachts de luxe, des parcours de golf, des plages et une vie nocturne animée.",
    },
    {
      id: 4,
      name: "Albufeira",
      image: "/location5.jpg",
      description: "Station balnéaire populaire connue pour ses belles plages, sa vie nocturne animée et sa vieille ville charmante.",
    },
    {
      id: 5,
      name: "Faro",
      image: "/location5.jpg",
      description: "Capitale de l'Algarve, avec une vieille ville historique, des attractions culturelles et une porte d'entrée vers la Ria Formosa.",
    },
    {
      id: 6,
      name: "Portimão",
      image: "/location5.jpg",
      description: "Grand port de pêche et station balnéaire, célèbre pour ses plages et ses activités nautiques.",
    },
    {
      id: 7,
      name: "Lagoa",
      image: "/location5.jpg",
      description: "Charmante ville connue pour sa production de vin et sa proximité avec de belles plages et grottes.",
    },
    {
      id: 8,
      name: "Quarteira",
      image: "/location5.jpg",
      description: "Ville de pêche traditionnelle devenue station balnéaire, offrant une longue promenade en bord de mer et des restaurants de fruits de mer frais.",
    },
    {
      id: 9,
      name: "Alcantarilha",
      image: "/location5.jpg",
      description: "Quarteira é uma cidade costeira tradicional com um extenso passeio marítimo e excelentes restaurantes de peixe e marisco.",
    }
  ],
  ui: {
    header: {
      phoneLabel: "(Réseau fixe national)",
      menu: {
        advantages: "Avantages",
        access: "Accès",
        partnership: "Partenariat",
        about: "Le saviez-vous...",
        contact: "Contact"
      }
    },
    sidebar: {
      categories: "Catégories",
      other: "Autres",
      language: "Langue"
    },
    searchBar: {
      searchPlaceholder: "Rechercher des expériences...",
      allCategories: "Toutes les Catégories",
      allLocations: "Toutes les Localités"
    },
    listPage: {
      specialOffer: "Offre Spéciale"
    },
    footer: {
      bookHoliday: "Réservez votre maison de vacances",
      allRightsReserved: "Tous droits réservés"
    },
    homepage: {
      title: "Clever Member",
      subtitle: "Profitez des récompenses exclusives",
      seeMore: "voir plus",
      store: "Boutique",
      new: "NOUVEAU"
    },
    access: {
      mainText1: "Ces avantages sont réservés à ceux qui réservent leurs vacances avec Clever Details ou nous confient leur propriété. C'est notre façon de vous remercier en rendant votre séjour ou votre investissement encore plus gratifiant.",
      mainText2: "Explorez la liste complète des avantages partenaires et profitez de bien plus qu'un simple séjour.",
      mainText3: "Avec Clever Details, vos vacances ou votre maison viennent avec bien plus qu'une simple clé.",
      exploreHomes: "Explorez nos maisons"
    },
    partnership: {
      title: "Pourquoi devenir partenaire de Clever Details ?",
      benefit1: {
        title: "Touchez plus de 6 000 clients de qualité par an",
        description: "Notre réseau comprend des milliers de touristes nationaux et internationaux qui valorisent les expériences locales"
      },
      benefit2: {
        title: "Augmentez la visibilité de votre entreprise",
        description: "Nous mettons en valeur votre entreprise sur notre site web et nos réseaux sociaux, augmentant votre portée."
      },
      form: {
        title: "Demande de partenariat",
        businessName: "Nom de l'entreprise",
        contactName: "Nom du contact",
        email: "Email",
        phone: "Téléphone",
        businessType: {
          label: "Type d'entreprise",
          placeholder: "Sélectionnez un type d'entreprise",
          options: {
            boatTours: "Tours en bateau",
            restaurants: "Restaurants",
            activities: "Activités",
            winery: "Cave à vin",
            wellness: "Bien-être",
            chefService: "Service de chef",
            other: "Autre"
          }
        },
        description: "Description de l'entreprise",
        submit: "Soumettre la demande",
        submitting: "Soumission en cours..."
      }
    },
    about: {
      title: "L'Histoire de Vilamoura et de sa Marina",
      subtitle: "D'une Ferme en Algarve à une Destination Touristique Internationale",
      video: {
        title: "Découvrez l'histoire"
      },
      curiosities: {
        title: "7 Curiosités de Vilamoura"
      },
      history: {
        visionaryDream: {
          title: "Le Rêve Visionnaire d'Arthur Cupertino de Miranda",
          content: "Dans les années 60, l'Algarve était l'une des régions les plus pauvres du Portugal. En 1964, le banquier et entrepreneur Arthur Cupertino de Miranda acquit l'ancienne \"Quinta de Quarteira\" avec une vision audacieuse : transformer un territoire agricole en l'un des plus grands pôles touristiques du pays.\n\nSon idée semblait excentrique pour l'époque : construire une ville planifiée de toutes pièces, avec hôtels, casino, terrains de golf et une marina, quelque chose d'inédit au Portugal. Mais le temps a prouvé qu'il était très en avance sur sa génération.",
          image: "/images/01-quinta-do-morgado-1960s - cópia.jpg"
        },
        primeiroSimbolo: {
          title: "Premier symbole de Vilamoura",
          content: "Ce fut le premier symbole de Vilamoura.\nLe coq a été choisi par le fondateur lui-même, Arthur Cupertino de Miranda, originaire du nord du Portugal.",
          image: "/images/Captura de ecrã 2025-09-22, às 15.54.25.jpeg"
        },
        marinaBirth: {
          title: "La Naissance de la Marina de Vilamoura",
          content: "En 1970, le gouvernement a officiellement approuvé le projet et, l'année suivante, les excavations de la future marina ont commencé.\nTrois ans plus tard, en avril 1974, la première marina du Portugal était inaugurée.\n\nLe moment le plus attendu fut l'arrivée du premier bateau : le légendaire voilier Giralda, de Son Altesse Royale D. Juan, Comte de Barcelone. Invité par Cupertino de Miranda, ce fut lui qui entra officiellement dans la Marina de Vilamoura, marquant le début d'une nouvelle ère pour le tourisme algarvien.",
          image: "/images/04-first-boat-vilamoura-marina-1974 - cópia.jpg"
        },
        vilamouraGrowth: {
          title: "Vilamoura Grandit Autour de la Marina",
          content: "La marina était le cœur du projet, mais Vilamoura a rapidement commencé à prendre vie par elle-même.\nCe que beaucoup considéraient comme excessif, mille postes d'amarrage pour bateaux, est devenu le moteur qui a attiré les visiteurs nationaux et internationaux.\n\nDans les années suivantes, sont nés hôtels, terrains de golf, restaurants et espaces de loisirs qui ont consolidé Vilamoura comme destination d'excellence.",
          image: "/images/08-vilamoura-marina-aerial-1977 - cópia.jpg"
        },
        commerce: {
          title: "Le Commerce et la Vie dans la Marina",
          content: "Peu après son inauguration, en 1978, la Marina a gagné un espace commercial qui comprenait plus de 50 magasins. On y trouvait coiffeurs, glaciers, bijouteries, parfumeries, chaussures, librairies et même disquaires (magasins de vente de disques). Le premier magasin à ouvrir fut la Geladaria Veneza, devenant rapidement un point de rencontre iconique.\n\nCe centre commercial a apporté modernité, diversité et vie à la région, créant un véritable écosystème urbain et touristique.",
          image: "/images/10-vilamoura-marina-inland-to-ocean-1980 - cópia.jpg"
        },
        vilamouraToday: {
          title: "Vilamoura Aujourd'hui",
          content: "Après 50 ans, la Marina de Vilamoura reste la plus prestigieuse et animée du Portugal. Autour d'elle a grandi une ville vibrante, avec des dizaines de développements touristiques, hôtels de luxe, restaurants, bars et magasins qui emploient plus de 1 500 personnes.\n\nPlus qu'un port de plaisance, la Marina est devenue le symbole de Vilamoura : innovation, qualité et style de vie méditerranéen.",
          image: "/images/1.jpg"
        },
        continuingStory: {
          title: "Une Histoire qui Continue",
          content: "De la vision d'un homme est né l'une des destinations touristiques les plus emblématiques du monde.\nLa Marina de Vilamoura est aujourd'hui un jalon dans l'histoire de l'Algarve et une fierté du Portugal."
        },
        timeline: {
          title: "Moments Marquants de l'Histoire de la Marina",
          events: [
            { year: "1964", event: "Arthur Cupertino de Miranda achète la Quinta de Quarteira pour créer un grand projet touristique" },
            { year: "1971", event: "Début des travaux de la Marina de Vilamoura" },
            { year: "1974", event: "Achèvement de la première marina du Portugal. Le voilier Giralda est le premier à accoster" },
            { year: "1978", event: "Ouverture du Centre Commercial de la Marina" },
            { year: "1997", event: "Premier Vilamoura Boat Show" },
            { year: "2010", event: "Première distinction comme Meilleure Marina du Portugal" },
            { year: "2015–2017", event: "Meilleure Marina Internationale (TYHA)" },
            { year: "2023", event: "Première marina au Portugal avec certification 5 Gold Anchor Platinum" },
            { year: "2024", event: "Début de la construction de la nouvelle marina" },
            { year: "2025", event: "Fin de la construction de la nouvelle marina. Plus de 1000 postes d'amarrage, centre de loisirs, commerce et tourisme, icône de l'Algarve" }
          ]
        }
      },
      slideshow: {
        title: "L'Évolution de la Marina de Vilamoura",
        description: ""
      },
      activities: {
        title: "Activités à Vilamoura",
        description: "Découvrez les meilleures expériences que Vilamoura a à offrir",
        items: [
          {
            title: "Golf",
            description: "5 terrains de golf de classe mondiale",
            icon: "golf"
          },
          {
            title: "Marina",
            description: "Marina privée pour 1 000 bateaux",
            icon: "anchor"
          },
          {
            title: "Plages",
            description: "Plages de sable doré et eaux cristallines",
            icon: "beach"
          },
          {
            title: "Gastronomie",
            description: "40+ restaurants avec des chefs primés",
            icon: "restaurant"
          },
          {
            title: "Voile",
            description: "Expériences uniques de navigation et sports nautiques",
            icon: "sail"
          },
          {
            title: "Padel",
            description: "Sport moderne et amusant pour tous les âges",
            icon: "padel"
          },
          {
            title: "Mode de Vie",
            description: "Découvrez le style de vie méditerranéen ultime",
            icon: "lifestyle"
          }
        ]
      },
      location: {
        title: "Emplacement Privilégié",
        description: "Vilamoura est stratégiquement située au cœur de l'Algarve",
        content: "À seulement 20 minutes de l'aéroport de Faro, Vilamoura offre un accès facile à toutes les principales attractions de l'Algarve, y compris Lagos, Albufeira et Tavira. Sa position centrale en fait le point de départ parfait pour explorer la région."
      },
      values: {
        title: "Nos Valeurs",
        subtitle: "Les principes qui guident tout ce que nous faisons",
        items: [
          {
            icon: "⭐",
            title: "Qualité",
            description: "Nous nous associons uniquement avec les meilleurs établissements, garantissant que chaque expérience répond à nos hauts standards d'excellence."
          },
          {
            icon: "🤝",
            title: "Partenariat",
            description: "Nous croyons en la construction de relations solides avec les entreprises locales, créant une valeur mutuelle et une croissance durable."
          },
          {
            icon: "🎯",
            title: "Exclusivité",
            description: "Nos membres bénéficient d'un accès spécial à des expériences et offres non disponibles au grand public."
          },
          {
            icon: "🌱",
            title: "Durabilité",
            description: "Nous nous engageons à promouvoir un tourisme responsable qui profite aux communautés locales et préserve notre bel environnement."
          },
          {
            icon: "💎",
            title: "Authenticité",
            description: "Nous nous concentrons sur des expériences locales authentiques qui mettent en valeur le véritable esprit et la culture de l'Algarve."
          },
          {
            icon: "❤️",
            title: "Service",
            description: "Notre équipe dévouée est toujours prête à aider, garantissant que votre expérience avec nous soit fluide et mémorable."
          }
        ]
      },
      team: {
        title: "Rencontrez Notre Équipe",
        subtitle: "Les personnes passionnées derrière We ❤️ Vilamoura",
        members: [
          {
            name: "Maria Silva",
            position: "Fondatrice & PDG",
            bio: "Avec plus de 15 ans dans l'industrie touristique, Maria a fondé We ❤️ Vilamoura pour créer des connexions significatives entre les voyageurs et les expériences uniques qui rendent Vilamoura spécial.",
            image: "/images/team/maria-silva.jpg"
          },
          {
            name: "João Santos",
            position: "Directeur des Partenariats",
            bio: "João dirige nos relations partenaires, garantissant que nous travaillons avec les meilleures entreprises locales de Vilamoura pour fournir des expériences exceptionnelles à nos membres.",
            image: "/images/team/joao-santos.jpg"
          },
          {
            name: "Ana Costa",
            position: "Responsable de l'Expérience Client",
            bio: "Ana garantit que chaque invité reçoit une attention personnalisée et a accès aux expériences parfaites pour son séjour dans la belle Vilamoura.",
            image: "/images/team/ana-costa.jpg"
          }
        ]
      },
      cta: {
        title: "Découvrez nos propriétés près de la Marina",
        content: "Vivez l'histoire de Vilamoura de près. Découvrez nos propriétés exclusives et faites partie de cette histoire unique.",
        propertiesButton: "Voir les Propriétés",
        propertiesLink: "https://cleverdetails.com"
      }
    },
    contact: {
      title: "Contactez-nous",
      form: {
        name: {
          label: "Nom",
          placeholder: "Votre nom"
        },
        phone: {
          label: "Téléphone",
          placeholder: "Votre numéro de téléphone"
        },
        email: {
          label: "Email",
          placeholder: "votre.email@exemple.com"
        },
        subject: {
          label: "Sujet",
          placeholder: "Sujet du message"
        },
        message: {
          label: "Message",
          placeholder: "Votre message ici..."
        },
        submit: "Envoyer le message",
        sending: "Envoi en cours..."
      }
    },
    itemDetails: {
      reviews: "avis",
      bookNow: "Réserver maintenant",
      specialOffer: "Vous le méritez !",
      bookingNotice: "Les réservations doivent être effectuées directement auprès de l'équipe Clever Details",
      bookingNotice2: "Vous devez présenter votre carte de membre à votre arrivée.",
      details: "Détails",
      openingHours: "Heures d'ouverture",
      location: "Emplacement",
      bookingRequest: "Demande de Réservation",
      bookingMessage: "Bonjour, je suis intéressé(e) par la réservation de {itemName} avec l'offre spéciale suivante : {specialOffer}.\\n\\nMerci de me fournir plus d'informations.",
      reviewsSection: {
        title: "Avis",
        leaveReview: "Laisser un avis",
        rating: "Note",
        writeReview: "Écrire un avis",
        authorPlaceholder: "Votre nom",
        commentPlaceholder: "Écrivez votre commentaire...",
        submit: "Envoyer l'avis",
        submitting: "Envoi en cours...",
        yourName: "Votre nom",
        writeComment: "Écrivez votre commentaire..."
      },
      dateList: {
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche"
      }
    },
    shopping: {
      title: "Boutique",
      subtitle: "Découvrez notre collection exclusive de produits de l'Algarve",
      addToCart: "Ajouter au Panier",
      removeFromCart: "Retirer du Panier",
      viewCart: "Voir le Panier",
      cart: "Panier",
      cartEmpty: "Votre panier est vide",
      total: "Total",
      checkout: "Commander",
      quantity: "Quantité",
      inStock: "En Stock",
      outOfStock: "Rupture de Stock",
      price: "Prix",
      cartItems: "Articles du Panier",
      cartTotal: "Total du Panier",
      proceedToCheckout: "Procéder au Paiement",
      continueShopping: "Continuer les Achats",
      removeItem: "Retirer l'Article",
      updateQuantity: "Mettre à Jour la Quantité"
    },
    checkout: {
      title: "Commande",
      subtitle: "Finalisez votre commande",
      orderSummary: "Résumé de la Commande",
      shippingInfo: "Informations de Livraison",
      paymentInfo: "Informations de Paiement",
      personalInfo: "Informations Personnelles",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      address: "Adresse",
      city: "Ville",
      postalCode: "Code Postal",
      country: "Pays",
      cardNumber: "Numéro de Carte",
      expiryDate: "Date d'Expiration",
      cvv: "CVV",
      cardholderName: "Nom du Titulaire",
      placeOrder: "Passer la Commande",
      processing: "Traitement en cours...",
      orderComplete: "Commande Terminée!",
      thankYou: "Merci pour votre achat!",
      orderNumber: "Numéro de Commande",
      contactConfirmation: "Vous serez contacté bientôt pour confirmer votre achat.",
      pickupLocationConfirmation: "Vous serez contacté pour confirmer l'emplacement exact de retrait.",
      continueShopping: "Continuer les Achats",
      subtotal: "Sous-total",
      shipping: "Livraison",
      total: "Total",
      freeShipping: "Gratuit",
      required: "Ce champ est obligatoire",
      invalidEmail: "Veuillez entrer un email valide",
      invalidPhone: "Veuillez entrer un numéro de téléphone valide",
      invalidCard: "Veuillez entrer un numéro de carte valide",
      invalidExpiry: "Veuillez entrer une date d'expiration valide (MM/AA)",
      invalidCvv: "Veuillez entrer un CVV valide",
      pickupInformation: "Informations de Retrait",
      pickupLocation: "Lieu de Retrait",
      selectPickupLocation: "Sélectionner le lieu de retrait",
      pickupDate: "Date de Retrait",
      pickupTime: "Heure de Retrait",
      selectTime: "Sélectionner l'heure",
      paymentMethod: "Méthode de Paiement",
      selectPaymentMethod: "Sélectionner la Méthode de Paiement",
      creditCard: "Carte de Crédit",
      soon: "(bientôt)",
      cash: "Espèces"
     },
    shoppingItem: {
      backToShopping: "Retour à la Boutique",
      addToCart: "Ajouter au Panier",
      inStock: "En Stock",
      outOfStock: "Rupture de Stock",
      description: "Description",
      specifications: "Spécifications",
      reviews: "Avis",
      relatedProducts: "Plus d'Articles",
      quantity: "Quantité",
      price: "Prix",
      category: "Catégorie",
      availability: "Disponibilité",
      shipping: "Livraison",
      returns: "Retours",
      warranty: "Garantie",
      features: "Caractéristiques",
      dimensions: "Dimensions",
      weight: "Poids",
      material: "Matériau",
      origin: "Origine",
      brand: "Marque",
      sku: "Référence"
    }
  }
}; 
